/**
 * 차트 Point에서 마우스 우 클릭시 Context Menu 처리 구현
 */

// import { ToastProgrammatic as Toast } from 'buefy'

// import Plotly from 'plotly.js-dist'
// import BriqueChart from './BriqueChart.vue'
// import EventHandler from './EventHandler.js'

export default {
  /**
   * Point에서 마우스 우측 버튼 클릭 기능 초기화(이벤트 등록)
   * @param {Object} element 차트 Element Object
   */
  initPointContextMenu (element) {
    // EventHandler.removeAndAddEventListener(element, `contextmenu.${element.id}_chart_point_contextmenu`, (e) => {
    //   if (EventHandler.matches.call(e.target, 'rect.legendtoggle')) { // legend 영역의 우 클릭 방지
    //     e.stopPropagation()
    //     e.preventDefault()
    //     return false
    //   }

    //   if (!EventHandler.matches.call(e.target, 'rect.nsewdrag.drag')) return

    //   // visible한 메뉴가 하나도 없으면 메뉴 자체가 안보이게
    //   if (!element.parentElement.__vue__.pointContextMenu.list.some((item) => typeof (item.visible) === 'function' ? item.visible() : item.visible)) {
    //     return
    //   }

    //   var dbb = e.target.getBoundingClientRect()

    //   let xpx = e.clientX - dbb.left
    //   let ypx = e.clientY - dbb.top

    //   let clientX = e.clientX
    //   let clientY = e.clientY

    //   setTimeout(async () => {
    //     // console.log(`${xpx}, ${ypx}`)
    //     let points = await BriqueChart.getPoints(element, xpx, ypx, 'closest')
    //     if (!_.isEmpty(points)) {
    //       let curveNumber = points[0].curveNumber

    //       element.parentElement.__vue__.pointContextMenu.selectedSeriesName = element.data[curveNumber].name

    //       let oriCapacity = []
    //       element.data.map((_, i) => {
    //         oriCapacity[i] = element.data[i].opacity
    //         // element.briqueChartData.seriesStyles[i] = element.briqueChartData.seriesStyles[i] ?? {}
    //         // element.briqueChartData.seriesStyles[i].opacity = (i === curveNumber ? 1 : 0.2)

    //         element.briqueChartData.setSeriesStyle(i, { opacity: (i === curveNumber ? 1 : 0.2) })
    //       })

    //       // BriqueChart.restyle(element, 'opacity', vals)
    //       BriqueChart.react(element, element.data, undefined, undefined, undefined, false).then(() => {
    //         // 투명도 원복
    //         element.data.map((_, i) => {
    //           // element.data[i].opacity = oriCapacity[i]
    //           // element.briqueChartData.seriesStyles[i].opacity = oriCapacity[i] ?? 1

    //           element.briqueChartData.setSeriesStyle(i, { opacity: (oriCapacity[i] ?? 1) })
    //         })
    //       })

    //       element.parentElement.__vue__.pointContextMenu.visible = true

    //       setTimeout(() => {
    //         let menu = document.querySelector(`#chart_point_contextmenu_${element.id}`)

    //         let x = (clientX + menu.clientWidth) > document.body.clientWidth ? (clientX - menu.clientWidth) : clientX
    //         let y = (clientY + menu.clientHeight) > document.body.clientHeight ? (clientY - menu.clientHeight) : clientY

    //         menu.style.left = `${x}px`
    //         menu.style.top = `${y}px`
    //       })
    //     }
    //   })

    //   e.stopPropagation()
    //   e.preventDefault()

    //   return false
    // })

    // EventHandler.removeAndAddEventListener(document.body, `click.${element.id}_chart_point_contextmenu`, (e) => {
    //   // chart split 해제 후 없어진 element이면
    //   if (_.isEmpty(document.getElementById(element.id))) {
    //     EventHandler.removeEventListener(document.body, `click.${element.id}_chart_point_contextmenu`)
    //     return
    //   }

    //   if (element.parentElement.__vue__.pointContextMenu.visible !== true) {
    //     return
    //   }

    //   element.parentElement.__vue__.pointContextMenu.visible = false
    //   BriqueChart.react(element, element.data, undefined, undefined, undefined, false)
    // })
  }
}
